import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class ContentsManager extends ManagerBase {
	constructor () {
		super("contentsManager");
		this.remoteClassName = "contents";
	}

	getListByVolumeGuid (volumeGuid) {
		const rd = NousCore.api.createRequest({ filters: { volumeGuid } });
		const requestedAction = "get-list-by-reference-volume-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	getRelatorContentList (guid) {
		const rd = NousCore.api.createRequest({ item: { guid } });
		const requestedAction = "get-relator-content-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	search (filters) {
		const rd = NousCore.api.createRequest( {item: {filters} });
		const requestedAction = "search";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	searchWithFullResponse (filters) {
		const rd = NousCore.api.createRequest( {item: {filters} });
		const requestedAction = "search-with-full-response";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const contentsManager = new ContentsManager();

Shark.registerController(contentsManager);

export default contentsManager;
